//=require ../utils.js

class FP_Checkout {
	constructor() {
		this.vat_number_input = document.querySelector('.edd-vat-number-input');
		this.vat_number_input_value = this.vat_number_input ? this.vat_number_input.value : false;
		
		this.discount_input = document.querySelector('.edd-discount-code-field-wrap #edd-discount');
		this.discount_input_value = this.discount_input ? this.discount_input.value : false;
		
		this.init();
	}

	init() {
		this.determineWhetherToShowBillingContinueButton();
		
		document.addEventListener('blur', function(e) {
			this.determineWhetherToShowBillingContinueButton();
		}.bind(this), true);

		document.addEventListener('click', (e) => {
			this.onSelectPaymentMethod(e);
			this.onBillingDetailsContinue(e);
			this.onBillingDetailsEdit(e);
			this.onApplyDiscountButton(e);
			this.onShowDiscountInput(e);
			this.onStripePayNowClick(e);
		});
	
		document.addEventListener('focusout', (e) => {
			this.onVATChange(e);
			this.onDiscountApply(e);
		});

		jQuery('body').on('edd_gateway_loaded', (e, payment_method) => {
			this.onPaymentMethodChange(payment_method);
		});
		jQuery('body').on('edd_discount_applied', (e, discount) => {
			this.onDiscountApplied(discount);
		});
		jQuery('body').on('edd_discount_invalid', (e, discount) => {
			this.onDiscountInvalid(discount);
		});
		jQuery('body').on('edd_discount_failed', (e, discount) => {
			this.onDiscountFailed(discount);
		});
		jQuery('body').on('edd_discount_removed', (e, discount) => {
			this.onDiscountRemoved(discount);
		});
		jQuery('body').on('edd_taxes_recalculated', (e, data) => {
			this.onTaxesRecalculation(data);
		});
		jQuery('body').on('edd_checkout_error', (e, data) => {
			this.resetStripePayment();
		});
	}

	onStripePayNowClick(e) {
		let btn = e.target.closest('.checkout-summary-action-cc .edd-submit');
		if (!btn) {
			return;
		}

		// Make step 3 non working
		let step3Wrapper = document.querySelector('.fp-checkout-tabs--item[data-tab="step-3"]');
		step3Wrapper.classList.add('is-working');

		// Make step 4 non working
		let step4Wrapper = document.querySelector('.fp-checkout-tabs--item[data-tab="step-4"]');
		step4Wrapper.classList.add('is-working');

		// Make button apper as processing
		btn.value = 'Processing...';
	}

	resetStripePayment() {
		// Make step 3 non working
		let step3Wrapper = document.querySelector('.fp-checkout-tabs--item[data-tab="step-3"]');
		step3Wrapper.classList.remove('is-working');

		// Make step 4 non working
		let step4Wrapper = document.querySelector('.fp-checkout-tabs--item[data-tab="step-4"]');
		step4Wrapper.classList.remove('is-working');

		// Make payment button normal
		document.querySelector('.checkout-summary-action-cc .edd-submit').value = 'Pay Now';
	}

	onShowDiscountInput(e) {
		let input = e.target.closest('.edd_discount_link');
		if (!input) {
			return;
		}

		let wrapper = input.closest('.edd-blocks-cart__discount');
		let discountCodeWrap = document.querySelector('#edd-discount-code-wrap');

		if (wrapper.classList.contains('show-discount-input')) {
			wrapper.classList.remove('show-discount-input');
		} else {
			wrapper.classList.add('show-discount-trigger');
			wrapper.classList.add('show-discount-input');
			discountCodeWrap.querySelector('input[name="edd-discount"]').focus();
		}

		discountCodeWrap.querySelector('.edd_error').innerHTML = '';
		discountCodeWrap.querySelector('.edd_error').style.display = 'none';
	}

	onDiscountApplied(discount) {
		const summarySidebarForm = document.querySelector('#edd_checkout_form_wrap');
		
		const wrapper = document.querySelector('.edd-blocks-cart__discount');

		if (discount.msg === 'valid') {
			// Remove existing discount
			if (wrapper.querySelector('.fp-checkout-discount-details')) {
				wrapper.querySelector('.fp-checkout-discount-details').remove();
			}

			wrapper.classList.add('discount-code-applied');

			// Show discount details
			wrapper.classList.remove('hide-discount-details');
			wrapper.classList.remove('show-discount-trigger');
			wrapper.classList.remove('show-discount-input');

			// Hide discount input
			document.querySelector('#edd-discount-code-wrap').style = 'display: none;';

			// Add the discount details from the template
			let template = document.querySelector('#fp-checkout-discount-details-template');

			// Get the contents
			const templateContent = template.innerHTML;

			// Replacements
			const data = {
				DISCOUNT_CODE: discount.code,
				DISCOUNT_AMOUNT: discount.amount,
				DISCOUNT_TOTAL: discount.discount_from_total
			};
			
			// Make replacements
			const renderedContent = templateContent
				.replace('{{DISCOUNT_CODE}}', data.DISCOUNT_CODE)
				.replace('{{DISCOUNT_AMOUNT}}', data.DISCOUNT_AMOUNT)
				.replace('{{DISCOUNT_TOTAL}}', data.DISCOUNT_TOTAL);

			// Prepend to wrapper
			wrapper.innerHTML = renderedContent + wrapper.innerHTML;

			// Update Discount Remove button code
			wrapper.querySelector('.edd_discount_remove').setAttribute('data-code', discount.code);

			// Update subtotal
			document.querySelector('.edd_cart_subtotal_amount').innerHTML = discount.subtotal;
		}

		// Hide discount input field
		wrapper.classList.add('hide-discount-input-container');

		summarySidebarForm.classList.remove('is-loading');
	}

	onDiscountInvalid(discount) {
		const summarySidebarForm = document.querySelector('#edd_checkout_form_wrap');
		summarySidebarForm.classList.remove('is-loading');

		// Remove discount code applied class
		const wrapper = document.querySelector('.edd-blocks-cart__discount');
		wrapper.classList.remove('discount-code-applied');
	}

	onDiscountFailed(discount) {
		const summarySidebarForm = document.querySelector('#edd_checkout_form_wrap');
		summarySidebarForm.classList.remove('is-loading');

		// Remove discount code applied class
		const wrapper = document.querySelector('.edd-blocks-cart__discount');
		wrapper.classList.remove('discount-code-applied');
	}

	onDiscountRemoved(discount) {
		const summarySidebarForm = document.querySelector('#edd_checkout_form_wrap');
		const wrapper = document.querySelector('.edd-blocks-cart__discount');

		// Remove discount code applied class
		wrapper.classList.remove('discount-code-applied');

		// Hide discount details
		wrapper.classList.add('hide-discount-details');

		// Show the discount input container
		wrapper.classList.remove('hide-discount-input-container');
		
		// Update the subtotal
		document.querySelector('.edd_cart_subtotal_amount').innerHTML = document.querySelector('.edd_cart_item_price').innerHTML.trim();

		// Remove existing discount details
		wrapper.querySelector('.fp-checkout-discount-details').remove();

		// Show the "Insert discount code" container
		wrapper.classList.add('show-discount-trigger');

		summarySidebarForm.classList.remove('is-loading');
	}

	onTaxesRecalculation(data) {
		// Update tax label
		document.querySelector('.fp-cart-item-tax-amount').innerHTML = '€' + data.response.tax_raw;

		// Update tax data attribute
		document.querySelector('.fp-cart-item-tax-amount').setAttribute('data-tax', data.response.tax_raw);

		// Update tax rate
		document.querySelectorAll('.checkout-cart-tax-rate').forEach(element => {
			element.innerHTML = data.response.tax_rate;
			element.setAttribute('data-tax-rate', data.response.tax_rate_raw);
		});

		// Update cart total
		document.querySelectorAll('.checkout-cart-total').forEach(element => {
			element.innerHTML = data.response.total;
		});

		// Update renewal price based on tax rate
		let renewalPriceElem = document.querySelector('.subscription-renewal-price');
		let initialPrice = parseFloat(renewalPriceElem.dataset.initialPrice);
		initialPrice = initialPrice - (0.3 * initialPrice);
		let renewalPrice = initialPrice + (initialPrice * data.response.tax_rate_raw);
		renewalPrice = Math.round(parseFloat(renewalPrice) * 100) / 100;
		renewalPriceElem.innerHTML = '€' + renewalPrice;

		// Collapse the buy now button of Stripe
		let isStep3Closed = document.querySelector('.fp-checkout-tabs--item[data-tab="step-3"][data-closed]');
		if (!isStep3Closed) {
			// Hide temp button
			document.querySelector('.checkout-temporary-pay-button').classList.remove('is-hidden');
			document.querySelector('.checkout-summary-actions').classList.add('is-hidden');
		} else {
			document.querySelector('.checkout-temporary-pay-button').classList.add('is-hidden');
			document.querySelector('.checkout-summary-actions').classList.remove('is-hidden');
		}
	}

	onApplyDiscountButton(e) {
		let btn = e.target.closest('.checkout-apply-discount');
		if (!btn) {
			return;
		}

		e.preventDefault();

		let formWrap = btn.closest('#edd_checkout_form_wrap');
		formWrap.classList.add('is-loading');

		let wrapper = btn.closest('#edd-discount-code-wrap');

		let discount = wrapper.querySelector('#edd-discount').value.trim();
		if (discount === '') {
			let errorMsg = wrapper.querySelector('.edd-alert');

			formWrap.classList.remove('is-loading');
	
			errorMsg.innerHTML = 'Please enter a coupon code';
			errorMsg.style = '';
			return;
		}
		
		wrapper.querySelector('.edd-apply-discount').click();
	}

	determineWhetherToShowBillingContinueButton() {
		let step3 = document.querySelector('.fp-checkout-tabs--item[data-tab="step-3"]');
		if (!step3) {
			return;
		}
		
		let emailElem = step3.querySelector('input[name="edd_email"]');
		let email = emailElem.value.trim();
		let first_name = step3.querySelector('input[name="edd_first"]').value.trim();
		let last_name = step3.querySelector('input[name="edd_last"]').value.trim();
		let country = step3.querySelector('select[name="billing_country"]').value.trim();
		
		let continueBtn = step3.querySelector('.fp-checkout-billing-continue');

		// Show billing customer info details
		let billingCustomerInfoLabel = step3.querySelector('.fp-checkout-billing-customer-info');
		let fullname = '';
		if (billingCustomerInfoLabel) {
			fullname = first_name;
			if (last_name) {
				if (first_name) {
					fullname += ' ';
				}
				
				fullname += last_name;
			}
			billingCustomerInfoLabel.innerHTML = fullname;
		}

		// Show/hide Continue button
		if (email !== '' && first_name !== '' && country !== '') {
			continueBtn.removeAttribute('disabled');
		} else {
			continueBtn.setAttribute('disabled', 'disabled');
		}
	}

	onBillingDetailsContinue(e) {
		let btn = e.target.closest('.fp-checkout-billing-continue');
		if (!btn) {
			return;
		}

		e.preventDefault();

		// Close the panel
		btn.closest('.fp-checkout-tabs--item[data-tab="step-3"]').setAttribute('data-closed', true);

		if (document.querySelector('#edd-purchase-button')) {
			document.querySelector('#edd-purchase-button').removeAttribute('disabled');
		}

		// Hide temp pay button
		document.querySelector('.checkout-temporary-pay-button').classList.add('is-hidden');
		document.querySelector('.checkout-summary-actions').classList.remove('is-hidden');

		let paymentMethod = document.querySelector('input[name="payment-mode"]:checked').value;
		if (paymentMethod === 'paypal_commerce') {
			document.querySelector('.checkout-summary-action-cc').classList.add('hide');
		} else if (paymentMethod === 'stripe') {
			document.querySelector('.checkout-summary-action-paypal').classList.add('hide');
		}
	}

	onBillingDetailsEdit(e) {
		let btn = e.target.closest('.fp-billing-details-edit-open');
		if (!btn) {
			return;
		}

		// Open the panel
		btn.closest('.fp-checkout-tabs--item[data-tab="step-3"]').removeAttribute('data-closed');

		// Show temp pay button
		document.querySelector('.checkout-temporary-pay-button').classList.remove('is-hidden');
		document.querySelector('.checkout-summary-actions').classList.add('is-hidden');
	}

	onSelectPaymentMethod(e) {
		let btn = e.target.closest('.edd-gateway-option');
		if (!btn) {
			return;
		}

		let payment_method = btn.querySelector('input.edd-gateway');
		if (!payment_method) {
			return;
		}

		// Abort already clicked payment
		if (payment_method.checked) {
			return;
		}

		if (['stripe', 'paypal_commerce'].includes(payment_method.value)) {
			let stepWrapper = btn.closest('.fp-checkout-tabs--item[data-tab="step-4"]');
			stepWrapper.classList.add('is-working');
		}

		let summaryActions = document.querySelector('.checkout-summary-actions');

		summaryActions.classList.add('is-disabled');

		let cardSubmit = summaryActions.querySelector('.checkout-summary-action-cc .edd-submit');

		if (payment_method.value === 'manual') {
			// Make the button enabled
			if (cardSubmit) {
				cardSubmit.removeAttribute('disabled');
				cardSubmit.removeAttribute('readonly');
				cardSubmit.removeAttribute('data-edd-button-state');
			}

			// Show the Stripe button
			summaryActions.querySelector('.checkout-summary-action-cc').classList.remove('hide');
			
			// Hide the PayPal button
			summaryActions.querySelector('.checkout-summary-action-paypal').classList.add('hide');

			summaryActions.classList.remove('is-disabled');
		} else if (payment_method.value === 'paypal_commerce') {
			// Disable the Stripe submit button
			if (cardSubmit) {
				cardSubmit.setAttribute('disabled', 'disabled');
			}

			// Hide the Stripe button
			summaryActions.querySelector('.checkout-summary-action-cc').classList.add('hide');
			
			// Show PayPal Placeholder Button
			summaryActions.querySelector('.checkout-summary-action-paypal .paypal-placeholder-btn').classList.remove('hide');

			// Show the PayPal button
			summaryActions.querySelector('.checkout-summary-action-paypal').classList.remove('hide');
		} else {
			// Disable the Stripe submit button
			if (cardSubmit) {
				cardSubmit.setAttribute('disabled', 'disabled');
			}
			
			// Hide the PayPal button
			summaryActions.querySelector('.checkout-summary-action-paypal').classList.add('hide');

			// Hide PayPal Placeholder Button
			summaryActions.querySelector('.checkout-summary-action-paypal .paypal-placeholder-btn').classList.add('hide');

			// Show the Stripe button
			summaryActions.querySelector('.checkout-summary-action-cc').classList.remove('hide');
		}

		// Remove the existing paypal button
		let button = summaryActions.querySelector('#edd-paypal-container .paypal-buttons');
		if (button) {
			button.remove();
		}
	}

	onPaymentMethodChange(payment_method) {
		let summaryActions = document.querySelector('.checkout-summary-actions');

		let stepWrapper = document.querySelector('.fp-checkout-tabs--item[data-tab="step-4"]');
		stepWrapper.classList.remove('is-working');

		// Set gateway
		document.querySelector('input[name="edd-gateway"]').value = payment_method;

		summaryActions.classList.remove('is-disabled');

		if (payment_method === 'paypal_commerce') {
			// Hide PayPal Placeholder Button
			summaryActions.querySelector('.checkout-summary-action-paypal .paypal-placeholder-btn').classList.add('hide');
		} else if (payment_method === 'stripe') {
			let elem = document.querySelector('#edd_purchase_form_wrap input[name="card_name"]');

			if (elem) {
				// Focus
				elem.focus();
	
				// Scroll to it
				elem.scrollIntoView();
			}

			if (window.eddStripe.paymentElement && document.querySelector('#edd-stripe-payment-element')) {
				window.eddStripe.paymentElement.mount(document.querySelector('#edd-stripe-payment-element'));
			}
		}

		// Hide the previous error message
		if (summaryActions.querySelector('.edd-alert')) {
			summaryActions.querySelector('.edd-alert').remove();
		}
	}

	/**
	 * Applies VAT when we focus out of the VAT Number input field.
	 * 
	 * @param   {Event}  e 
	 * 
	 * @return  void
	 */
	onVATChange(e) {
		let vat_input = e.target.closest('.edd-vat-number-input');
		if (!vat_input) {
			return;
		}

		// do not proceed if the values are the same
		if (vat_input.value == this.vat_number_input_value) {
			return;
		}

		this.vat_number_input_value = vat_input.value;

		// check VAT ID
		EDD_EU_VAT.checkVatNumber(e);
	}

	/**
	 * Applies discount when we focus out of the discount input field.
	 * 
	 * @param   {Event}  e
	 * 
	 * @return  void
	 */
	onDiscountApply(e) {
		let input = e.target.closest('#edd-discount');
		if (!input) {
			return;
		}

		// do not proceed if the values are the same
		if (input.value == this.discount_input_value) {
			return;
		}

		if (input.value.trim() === '') {
			return;
		}

		this.discount_input_value = input.value;

		let summarySidebarForm = document.querySelector('#edd_checkout_form_wrap');
		summarySidebarForm.classList.add('is-loading');

		// check discount code
		input.nextElementSibling.click();
	}
}

FP_Utils.onReady(function() {
	new FP_Checkout();
});